
import Vue from 'vue'
import { AppModule } from '@/store/module'
import DemoShowCardLarge from '@/views/others/components/DemoShowCardLarge.vue'
import DemoShowCard from '@/views/others/components/DemoShowCard.vue'

export default Vue.extend({
  components: {
    DemoShowCardLarge,
    DemoShowCard,
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    demos() {
      return AppModule.demos
    },
    isH5() {
      return AppModule.isH5
    },
  },
  methods: {
    close() {
      this.$emit('update:isShow', false)
    },
  },
})
